<body>
    <div class="container">
        <div *ngIf="dataLoaded" class="table-container scrollable-container">
            <!-- <clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'xl'" class="dialog-container"> -->
            <div id="flitrarData" class="divInfoConteudo">
                <input id="dataInput" type="date" name="dataFiltro" [(ngModel)]="dataFiltro">
                <button class="select-input" (click)="dataFilter()">Filtrar</button>
                <!-- <input id="dataMostrar" name="dataMostra" [(ngModel)]="dataMostra" type="text"> -->
                <span id="dataMostrar">{{ dataMostra | date:'dd/MM/yyyy' }}</span>
            </div>
            <h3 class="modal-title">VOLUME DE RECEBIMENTO LCB</h3>
            <div class="modal-body">
                <form class="inputs">
                    <div *ngIf="dataLoaded" class="table-container scrollable-container">
                        <table class="geralTable">
                            <thead class="sticky-header">
                                <tr>
                                    <th class="col-op-width titulos-inserir">
                                        <span class="semFundo">OPERAÇÃO</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">TRANSPORTADORA</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">VEÍCULOS (QT.)</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">PALLETS (QT.)</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <span class="semFundo">MÉDIA (PALLET/VEÍCULO)</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="corpoTimeTable">
                                    <td class="centralizado">
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Direto Extra:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Diretos:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Aéreo:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo CRAGEA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo Santos:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo CRAGEA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo Santos:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo CRAGEA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Marítimo Santos:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run São
                                                    Paulo e Sul:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run Sul:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>     -->
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run
                                                    Argentina:
                                                </abbr>
                                            </span>
                                        </div>     
                                        <hr>                        
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">Milk Run Interior/SP e Minas Gerais:
                                                </abbr>
                                            </span>
                                        </div>                              
                                    </td>
                                    <td class="centralizado">
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">EXTRA:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">NORMAL:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">RODO IMPORT:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">LOTS:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">LOTS:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">SUZAN:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">SUZAN:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">GLOVIS:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">GLOVIS:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">JSL:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <!-- <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">JSL:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr> -->                                   
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">JSL:
                                                </abbr>
                                            </span>
                                        </div>
                                        <hr>
                                        <div class="tituloInputValue">
                                            <span>
                                                <abbr style="color: #000000; font-weight: bold;">TCM:
                                                </abbr>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="centralizado">
                                        <div class="inputValue marginCima">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosFE"
                                                [(ngModel)]="volRecebimento.qtVeiculosFE"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosDiretos"
                                                [(ngModel)]="volRecebimento.qtVeiculosDiretos"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosAereo"
                                                [(ngModel)]="volRecebimento.qtVeiculosAereo"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosCrageaLots"
                                                [(ngModel)]="volRecebimento.qtVeiculosCrageaLots"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaLots', volRecebimento.qtPalletsCrageaLots, volRecebimento.qtVeiculosCrageaLots)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaLots', volRecebimento.qtPalletsCrageaLots, volRecebimento.qtVeiculosCrageaLots)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosSantosLots"
                                                [(ngModel)]="volRecebimento.qtVeiculosSantosLots"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosCrageaSuzan"
                                                [(ngModel)]="volRecebimento.qtVeiculosCrageaSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosSantosSuzan"
                                                [(ngModel)]="volRecebimento.qtVeiculosSantosSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosCrageaGlovis"
                                                [(ngModel)]="volRecebimento.qtVeiculosCrageaGlovis"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaGlovis', volRecebimento.qtPalletsCrageaGlovis, volRecebimento.qtVeiculosCrageaGlovis)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaGlovis', volRecebimento.qtPalletsCrageaGlovis, volRecebimento.qtVeiculosCrageaGlovis)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosSantosGlovis"
                                                [(ngModel)]="volRecebimento.qtVeiculosSantosGlovis"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosGlovis', volRecebimento.qtPalletsSantosGlovis, volRecebimento.qtVeiculosSantosGlovis)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosGlovis', volRecebimento.qtPalletsSantosGlovis, volRecebimento.qtVeiculosSantosGlovis)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosMRjsl"
                                                [(ngModel)]="volRecebimento.qtVeiculosMRjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)">
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosMRjsl"
                                                [(ngModel)]="volRecebimento.qtVeiculosMRjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)">
                                        </div>
                                        <hr> -->
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosARGjsl"
                                                [(ngModel)]="volRecebimento.qtVeiculosARGjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtVeiculosMRtcm"
                                                [(ngModel)]="volRecebimento.qtVeiculosMRtcm"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)">
                                        </div>                                    
                                    </td>
                                    <td class="centralizado">
                                        <div class="inputValue marginCima">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsFE"
                                                [(ngModel)]="volRecebimento.qtPalletsFE"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaFE', volRecebimento.qtPalletsFE, volRecebimento.qtVeiculosFE)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsDiretos"
                                                [(ngModel)]="volRecebimento.qtPalletsDiretos"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaDiretos', volRecebimento.qtPalletsDiretos, volRecebimento.qtVeiculosDiretos)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsAereo"
                                                [(ngModel)]="volRecebimento.qtPalletsAereo"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaAereo', volRecebimento.qtPalletsAereo, volRecebimento.qtVeiculosAereo)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsCrageaLots"
                                                [(ngModel)]="volRecebimento.qtPalletsCrageaLots"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaLots', volRecebimento.qtPalletsCrageaLots, volRecebimento.qtVeiculosCrageaLots)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaLots', volRecebimento.qtPalletsCrageaLots, volRecebimento.qtVeiculosCrageaLots)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsSantosLots"
                                                [(ngModel)]="volRecebimento.qtPalletsSantosLots"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosLots', volRecebimento.qtPalletsSantosLots, volRecebimento.qtVeiculosSantosLots)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsCrageaSuzan"
                                                [(ngModel)]="volRecebimento.qtPalletsCrageaSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaSuzan', volRecebimento.qtPalletsCrageaSuzan, volRecebimento.qtVeiculosCrageaSuzan)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsSantosSuzan"
                                                [(ngModel)]="volRecebimento.qtPalletsSantosSuzan"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosSuzan', volRecebimento.qtPalletsSantosSuzan, volRecebimento.qtVeiculosSantosSuzan)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsCrageaGlovis"
                                                [(ngModel)]="volRecebimento.qtPalletsCrageaGlovis"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaCrageaGlovis', volRecebimento.qtPalletsCrageaGlovis, volRecebimento.qtVeiculosCrageaGlovis)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaCrageaGlovis', volRecebimento.qtPalletsCrageaGlovis, volRecebimento.qtVeiculosCrageaGlovis)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsSantosGlovis"
                                                [(ngModel)]="volRecebimento.qtPalletsSantosGlovis"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaSantosGlovis', volRecebimento.qtPalletsSantosGlovis, volRecebimento.qtVeiculosSantosGlovis)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaSantosGlovis', volRecebimento.qtPalletsSantosGlovis, volRecebimento.qtVeiculosSantosGlovis)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsMRjsl"
                                                [(ngModel)]="volRecebimento.qtPalletsMRjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)">
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsMRjsl"
                                                [(ngModel)]="volRecebimento.qtPalletsMRjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRjsl', volRecebimento.qtPalletsMRjsl, volRecebimento.qtVeiculosMRjsl)">
                                        </div>                                      
                                        <hr> -->
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsARGjsl"
                                                [(ngModel)]="volRecebimento.qtPalletsARGjsl"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaARGjsl', volRecebimento.qtPalletsARGjsl, volRecebimento.qtVeiculosARGjsl)">
                                        </div>
                                        <hr>                                
                                        <div class="inputValue">
                                            <input type="number" [disabled]="isAdminEnabled" id="quantidades" name="qtPalletsMRtcm"
                                                [(ngModel)]="volRecebimento.qtPalletsMRtcm"
                                                (focus)="selecionarTexto($event)"
                                                (keydown)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)"
                                                (blur)="onKeydownOrBlur($event, 'qtMediaMRtcm', volRecebimento.qtPalletsMRtcm, volRecebimento.qtVeiculosMRtcm)">
                                        </div>
                                    </td>
                                    <td class="centralizado">
                                        <div class="inputValue marginCima">
                                            <input [disabled]="true" type="number" id="quantidades" name="qtMediaFE"
                                                [ngModel]="volRecebimento.qtMediaFE" (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaDiretos" [ngModel]="volRecebimento.qtMediaDiretos"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades" name="qtMediaAereo"
                                                [ngModel]="volRecebimento.qtMediaAereo"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaCrageaLots" [ngModel]="volRecebimento.qtMediaCrageaLots"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaSantosLots" [ngModel]="volRecebimento.qtMediaSantosLots"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaCrageaSuzan" [ngModel]="volRecebimento.qtMediaCrageaSuzan"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaSantosSuzan" [ngModel]="volRecebimento.qtMediaSantosSuzan"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaCrageaGlovis"
                                                [ngModel]="volRecebimento.qtMediaCrageaGlovis"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades"
                                                name="qtMediaSantosGlovis"
                                                [ngModel]="volRecebimento.qtMediaSantosGlovis"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades" name="qtMediaMRjsl"
                                                [ngModel]="volRecebimento.qtMediaMRjsl"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>
                                        <!-- <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades" name="qtMediaMRjsl"
                                                [ngModel]="volRecebimento.qtMediaMRjsl"
                                                (focus)="selecionarTexto($event)">
                                        </div>                                     
                                        <hr> -->
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades" name="qtMediaARGjsl"
                                                [ngModel]="volRecebimento.qtMediaARGjsl"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                        <hr>                                    
                                        <div class="inputValue">
                                            <input [disabled]="true" type="number" id="quantidades" name="qtMediaMRtcm"
                                                [ngModel]="volRecebimento.qtMediaMRtcm"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="dataLoaded" class="table-container scrollable-container">
                        <table class="geralTable">
                            <thead class="sticky-header">
                                <tr>
                                    <th class="titulos-inserir" colspan="3">
                                        <span class="semFundo">TOTAL</span>
                                    </th>
                                    <th class="titulos-inserir">
                                        <div class="inputValue marginCima">
                                            <span>VEÍCULOS</span>
                                            <input [disabled]="true" type="text" name="veicTotal"
                                                [(ngModel)]="volRecebimento.veicTotal"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </th>
                                    <th class="titulos-inserir">
                                        <div class="inputValue marginCima">
                                            <span>PALLETS</span>
                                            <input [disabled]="true" type="text" name="palletsTotal"
                                                [(ngModel)]="volRecebimento.palletsTotal"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </th>
                                    <th class="titulos-inserir">
                                        <div class="inputValue marginCima">
                                            <span>MÉDIA</span>
                                            <input [disabled]="true" type="text" name="mediaTotal"
                                                [ngModel]="volRecebimento.mediaTotal | number:'1.2-2'"
                                                (ngModelChange)="volRecebimento.mediaTotal = $event"
                                                (focus)="selecionarTexto($event)">
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="modal-div botoes">
                        <button class="modal-button" type="button" (click)="salvar(volRecebimento)">Save</button>
                        <!-- <button class="modal-button" type="button" (click)="cancel()">Cancel</button> -->
                    </div>
                </form>
            </div>
            <!-- </clr-modal> -->

        </div>
    </div>
</body>


<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>